import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-975d8df4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-[100px] index-abouts" }
const _hoisted_2 = { class: "flex flex-wrap h-[1200px] w-[100%] about-copany" }
const _hoisted_3 = { class: "mr-[50%] w-[50%] h-[600px] pr-[120px] flex justify-end bg-[#F5F5F5]" }
const _hoisted_4 = { class: "w-[480px] pt-[101px]" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-title" }, "公司介绍", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-[14px] leading-[22px] mt-[28px] indent-[2em]" }, [
  /*#__PURE__*/_createTextVNode(" 广东省广晟财务有限公司（以下简称“公司”）成立于2015年6月，是经国家金融监督管理总局（原中国银行业监督管理委员会）批准成立的非银行金融机构，注册资本为人民币109,922万元，其中，广东省广晟控股集团有限公司（以下简称“集团”）持股90.974%，深圳市中金岭南有色金属股份有限公司持股6.943%，佛山市国星光电股份有限公司持股2.083%。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("div", { class: "indent-[2em]" }, " 公司坚持服务集团、赋能实体，通过资金管控和金融服务“双轮驱动”，加快数智化转型，打造金融资源统筹、综合服务、价值创造和风险防控四大平台，巩固优化现有业务，有序拓展培育业务，力争成为资金管家、金融专家、决策智囊，更好助力集团高质量发展。 ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ml-[40px] iconfont rotate-[-90deg] icon-xiangxiajiantou" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-[50%] w-[50%] h-[600px] flex justify-start bg-[#F5F5F5]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-[600px] pt-[101px] h-[100%] bgimage bg-cover bg-center" })
], -1))

import TitleComp from "./titleComp";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'AboutComp',
  setup(__props) {

const route = useRouter();
function goAboutUs() {
  route.push({ path: "/aboutus", query: { tab: 'intro' } });
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TitleComp), { title: "关于广晟财务公司" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createVNode(_component_el_button, {
            class: "mt-[34px]",
            onClick: goAboutUs
          }, {
            default: _withCtx(() => [
              _createTextVNode("查看更多 "),
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_8
    ])
  ]))
}
}

})